import container from "@/lib/di/container";
import { useEffect, useState } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { DetailModal } from "./modals/DetailModal";
import { Button, message, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { UnitTypeRepo } from "@/core/repos/tables/unit-type.repo";
import { UnitTypeModel, UnitTypeModelFactory } from "@/core/models/unit-type/unit-type.model";
import { formatCurrencyPipe } from "@/core/pipes/format-currency.pipe";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { DeleteButton } from "../../components/table/DeleteButton";

const unitTypeRepo = container.get(UnitTypeRepo);

export default function UnitTypePage() {
    const titleData = useTitleDataStore();
    const [modalData, setModalData] = useState<UnitTypeModel>(UnitTypeModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<UnitTypeModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tìm kiếm",
            placeholder: "Nhập nội dung tìm kiếm",
            type: FilterInputType.text,
        },
    ])

    const showDetail = (record: UnitTypeModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const init = async () => {
        titleData.setTitleActions({
            text: "Tạo Loại hình Đơn vị",
            onPress: () => {
                showDetail(UnitTypeModelFactory.getEmpty())
            }
        })
    }

    useEffect(()=>{init()}, []);

    const deleteSelected = async () => {
        setDeleting(true);
        const result = await unitTypeRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }


    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: UnitTypeModel[]) {
        setSelectedRows([...rows]);
    }

    return (
    <div className="px-4 py-6">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap}  actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<UnitTypeModel>
                columns={[
                    { dataIndex: 'name', name: 'Tên' },
                    { name: 'Bảng giá áp dụng', pipe: (value: UnitTypeModel) => value.feeLadder?.name??""},
                    { dataIndex: 'provinceName', name: 'Tỉnh/ TP áp dụng' },
                    { dataIndex: 'requiredDepositAmount', name: 'Tiền đặt cọc', pipe: formatCurrencyPipe },
                    {
                        name: 'Thao tác',
                        render: (_, record) => (
                                <div className="flex flex-row px-1 items-center justify-center">
                                    <Tooltip title="Sửa hợp đồng"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                                </div>
                            ),
                        fixed: "right"
                    },
                ]}
                repository={unitTypeRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
    </div>)
}